import request from '@/api/request.js'


// 查询组织架构树

export function getOrgTree (params) {
  return request({
    method: 'get',
    url: `/system/department/list`,
    params
  })
}

export function getUser () {
  return request({
    method: 'get',
    url: '/system/user/allList'
  })
}
// 查询系统角色
export function getRole () {
  return request({
    url: 'oa/org/role',
    method: 'get'
  })
}

// 搜索人员
export function getUserByName (param) {
  return request({
    url: '/system/user/allList',
    method: 'get',
    params: param
  })
}

export default {
  getOrgTree, getUserByName, getRole
}
